module.exports = __webpack_public_path__ + "img/8.2211587f.png";